export const COMMON_NAMESPACE = "common"
